"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var index_1 = require("../index");
exports.default = (function (_a) {
    var id = _a.id, values = _a.values;
    var html = { __html: (0, index_1.getDictionary)().text(id, values) };
    return (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: html });
});
